import { recordEventCustomOnly } from 'utilities/uTagging';
import { PATH_PROFESSION } from 'constants/uTagConstants/paths';

const buildTagging = () => {
    const doTagChangePatrimonyIncome = key => {
        recordEventCustomOnly({
            action: 'select',
            format: 'checkBox',
            component: 'form',
            element: `income/check${key}`,
            eventCategory: PATH_PROFESSION,
            eventAction: 'selectCheckBox',
            eventLabel: `income/check${key}`,
        });
    };

    return {
        doTagChangePatrimonyIncome,
    };
};

export default buildTagging;
